import { createContext } from 'react';
import { Stores } from 'src/stores';
import { StoresContextModel } from './types';

export const StoresContext = createContext<StoresContextModel>({
  stores: {} as Stores
});
